export enum TriggerStatus {
  UNSET_TRIGGER_STATUS = 'UNSET_TRIGGER_STATUS', // Do not use, needed because of proto3 limitations
  ACTIVATED = 'ACTIVATED',
  PAUSED = 'PAUSED',
  DELETED = 'DELETED',
}
